/**
 * Formats a number with appropriate abbreviation (K, M, B, T)
 * Always shows 3 significant digits + magnitude symbol.
 *  Examples:
 * 80100 → "80.1K"
 * 2500000 → "2.5M"
 * 1200000000 → "1.2B"
 * 1500 → "1.5K"
 * 800 → "800" (no abbreviation for numbers under 1000)
 * @param {number} num - The number to format
 * @returns {string} - Formatted number with abbreviation
 */
export const formatNumber = (num) => {
  // eslint-disable-next-line no-restricted-globals
  if (num === null || num === undefined || isNaN(num)) {
    return '0';
  }

  const absNum = Math.abs(num);

  // if the number is greater than 1 trillion
  if (absNum >= 1e12) {
    const value = num / 1e12;
    if (value >= 100) {
      return `${Math.floor(value)}T`;
    }
    return `${Math.floor(value * 100) / 100}T`;
  }

  // if the number is greater than 1 billion
  if (absNum >= 1e9) {
    const value = num / 1e9;
    if (value >= 100) {
      return `${Math.floor(value)}B`;
    }
    return `${Math.floor(value * 100) / 100}B`;
  }

  // if the number is greater than 1 million
  if (absNum >= 1e6) {
    const value = num / 1e6;
    if (value >= 100) {
      return `${Math.floor(value)}M`;
    }
    return `${Math.floor(value * 100) / 100}M`;
  }

  // if the number is greater than 1 thousand
  if (absNum >= 1e3) {
    const value = num / 1e3;
    if (value >= 100) {
      return `${Math.floor(value)}K`;
    }
    return `${Math.floor(value * 100) / 100}K`;
  }

  // if the number is less than 1 thousand
  return num.toString();
};
